import { graphqlGLClient } from '../../api/gqlaxy/gql/queries/graphQLClient'
import {
  ClientEventName,
  ClientEventSource,
  CreateClientEventMutation,
  CreateClientEventMutationVariables
} from '../../api/gqlaxy/gql/generated/graphql'
import { CreateClientEventDocument } from '../../api/gqlaxy/gql/generated/graphql-hooks'
import * as Sentry from '@sentry/browser'

export const UTM_CONTENT = {
  VIEW_YOUR_LISTING: 'view_your_listing'
}

/**
 * Fires a client event based on the utm_content query parameter.
 * This is called during the auth callback flow to track user engagement from email links.
 *
 * @param utmContent - The utm_content query parameter value that is defined and passed in from mikasa dynamic email data templates like we do here for example: app/services/api_email_delivery/client_emails/listing_alert/dynamic_data/v1.rb (Mikasa)
 */
export const fireClientEventFromUtmContent = async (utmContent: string, redirectUrl: string): Promise<void> => {
  const client = graphqlGLClient()

  try {
    switch (utmContent) {
      case UTM_CONTENT.VIEW_YOUR_LISTING: {
        await client.request<CreateClientEventMutation, CreateClientEventMutationVariables>(CreateClientEventDocument, {
          clientEventInput: {
            eventName: ClientEventName.ViewedTheirOwnListing,
            eventSource: ClientEventSource.ListingDetailed,
            listingId: redirectUrl.split('/').pop(), // grabs the listing id from the redirect url which is formatted like this when utm_content is 'view_your_listing': /home-search/{customerProfileId/listing/{listingId}
            properties: {
              activity_source: 'email'
            }
          }
        })
        break
      }
      default:
        // No-op we don't handle other utm_content values yet
        break
    }
  } catch (error) {
    Sentry.addBreadcrumb({
      category: 'clientEvent',
      message: 'Error firing client event from utm_content',
      level: 'error',
      data: {
        utmContent
      }
    })
    Sentry.captureException(error)
  }
}
